import * as Popover from '@radix-ui/react-popover';

import { cn } from '@components/primitives/utilities';

import css from './styles.module.css';

export type EQLFilterContentProps = Popover.PopoverContentProps;

export function EQLFilterContent({
  children,
  className,
  side = 'bottom',
  sideOffset = 12,
  ...props
}: EQLFilterContentProps) {
  return (
    <Popover.Portal>
      <Popover.Content
        asChild
        side={side}
        sideOffset={sideOffset}
        style={{ zIndex: 50 }}
        {...props}
      >
        <div className={cn(css.panel, className)}>
          <div className={css.body}>{children}</div>
        </div>
      </Popover.Content>
    </Popover.Portal>
  );
}
